// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1611125825
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';

export class Call {
  @Required()
  callId: string;
  @Required()
  @StringLength(50)
  contactId: string;
  @Required()
  directionId: number;
  memberId: string;
  @Required()
  @StringLength(50)
  callPartyPhone: string;
  memberCaseId: string;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
}

export function initializeNewCall(): Call {
  const instance = new Call();
  instance.callId = '00000000-0000-0000-0000-000000000000';
  instance.contactId = '00000000-0000-0000-0000-000000000000';
  instance.directionId = null;
  instance.memberId = '00000000-0000-0000-0000-000000000000';
  instance.callPartyPhone = '';
  instance.memberCaseId = '00000000-0000-0000-0000-000000000000';
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  return instance;
}
